import React from 'react';
import { connect } from 'react-redux';
import { routes } from 'constants/config';
import { Spinner } from 'ui';
import ReportingBlock from './Partials/ReportingBlock';
import ReportingBlockHeader from './Partials/ReportingBlockHeader';
import ReportingStat from './Partials/ReportingStat';
import ReportingStatGroup from './Partials/ReportingStatGroup';
import DataProvider from './Partials/DataProvider';

const LearningLibrary = ({ pathId, groupId }) => (
  <DataProvider
    url={routes.PATH_REPORTING.LIBRARY(pathId)}
    params={{ groupId }}
  >
    {({ data, loading }) => (
      <ReportingBlock>
        <ReportingBlockHeader title={t('learn.self_directed_learning')}>
          {data && (
            <a className="fz-bigger c-brand-blue ta-r" href={data.detailsUrl}>
              {t('learn.self_directed_learning_detail')}
            </a>
          )}
        </ReportingBlockHeader>
        {loading && <Spinner />}
        {!loading && (
          <ReportingStatGroup>
            <ReportingStat value={data.totalViews} label="Total Views" />
            <ReportingStat
              value={data.uniqueUserViews}
              label="Unique User Views"
            />
            <ReportingStat value={data.completions} label="Completions" />
          </ReportingStatGroup>
        )}
      </ReportingBlock>
    )}
  </DataProvider>
);

const mapStateToProps = ({ pathBuilder }) => ({
  pathId: pathBuilder.id,
  groupId: pathBuilder.reporting.groupId,
});

export default connect(mapStateToProps)(LearningLibrary);
